/** Ruta inexistente. Pasa cuando alguien pega un enlace viejo o mal copiado. */
import type { ReactElement } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MiddleMark } from '../components/MiddleLogo';
import { useDocumentTitle } from '../hooks/use-document-title';

export function NotFoundPage(): ReactElement {
  const location = useLocation();
  useDocumentTitle('Página no encontrada');

  return (
    <div className="page">
      <section className="not-found" aria-labelledby="not-found-title">
        <div className="not-found__brand">
          <MiddleMark size={28} />
          <span>
            <strong>Middle</strong>
            <span className="muted"> · Monitor de integraciones · Grupo Amoblé</span>
          </span>
        </div>
        <p className="not-found__code">404</p>
        <h1 id="not-found-title">Esa pantalla no existe</h1>
        <p className="muted">
          No hay nada en <span className="mono not-found__path">{location.pathname}</span>. Puede
          ser un enlace viejo o mal copiado.
        </p>
        <div className="row">
          <Link className="button button--primary" to="/tablero">
            Ir al tablero
          </Link>
          <Link className="button" to="/mensajes">
            Ir a los mensajes
          </Link>
        </div>
      </section>
    </div>
  );
}
